module.exports = __webpack_public_path__ + "static/img/errorPageIcon.c119c7c5.svg";